<template>
  <div class="content_main">
    <p class="content_normal">We are solicitors to the Flypay loan application. All charges against
      you have now been passed today as a clear indication that all allegations may have been
      correct. Any moment from now, a lien will be placed on your bank account, A file for a total
      ban on your profile from the credit bureau has been opened so that other loan companies can be
      aware of your attitude. Our legal department has sent a letter to the court for your summon.
      Kindly check your mailbox in the next hours for details of the summon. The paper version of
      our lawyer’s letter will be sent to the police station near your home. You are required to
      check appropriately and respond.</p>
    <br />
    <p class="content_normal">Note: It is not our practice to exhibit actions such as this but our
      company cannot afford to incur a further loss that will ruin the company completely. Kindly
      give the necessary cooperation in order to be able to help you.</p>
    <br />
    <p class="content_normal">If you are experiencing difficulty to repay, our company can waive the
      late payment fee of 50% and lets you repay the outstanding. Kindly respond to our recovery
      officers or contact: </p>
    <br />
    <p class="content_normal">WhatsApp-09120482700</p>
    <p class="content_normal">Email- collection@flypay.ng</p>
    <br />
    <p class="content_normal">This letter requires you to give an immediate response.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have the assurance of our best
      wishes.</p>
    <br />
    <p class="content_normal">Best regards</p>

  </div>
</template>

<script>
export default {
  name: 'flypayM5',
};
</script>


<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;

  .content_main {
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }

  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
